import { cn } from "@/utils/cn";
import { memo } from "react";

interface CalorieProgressFillProps {
  progressWidth: number;
}

export const CalorieProgressFill = memo(function CalorieProgressFill({
  progressWidth,
}: CalorieProgressFillProps) {
  const fillWidth = Math.max(0, Math.min(progressWidth, 100));
  const gradientWidth = fillWidth > 0 ? 10000 / fillWidth : 0;

  return (
    <div
      className="h-full overflow-hidden rounded-full transition-[width] duration-300 ease-out"
      style={{ width: `${fillWidth}%` }}
    >
      <div
        className={cn("h-full", "bg-gradient-to-r from-[#43246E] to-[#60418A]")}
        style={{ width: `${gradientWidth}%` }}
      />
    </div>
  );
});
